import { clsx } from 'clsx'
import { type FC, type FormEventHandler, useRef } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconShoppingCart } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config/context/globalConfigContext'
import { useProductPageContext } from '../../../product-page/components/productPageContext'
import { type ProductAddToCartProductPageMainCtaParams } from '../../../product-page/product-add-to-cart-params/productAddToCartParams'
import { urlResolverGetCartIntermediatePage } from '../../../url-handling/urlResolver'
import { EXPERIMENT_TRACK_EVENT_OWN_BRANDS_OVERLAY_ADD_TO_CART } from '../../eventTracking/EXPERIMENTS_TRACK_EVENT'
import { experimentsTrackEvent } from '../../eventTracking/experimentsTrackEvent'

import { EXPERIMENT_OWN_BRANDS_OVERLAY_ADD_TO_CART_FORM_ID } from './ExperimentOwnBrandsOverlayConsts'

import styles from '../../../product-page/components/ProductBuyBox/ProductAddToCartGroup/ProductAddToCartCta/ProductAddToCartCta.module.css'

export const ExperimentOwnBrandsOverlayAddToCartCta: FC<{
  addToCartParams: {
    disableCta: boolean
    isPrivatePrescriptionAndCartMetadataHasErx?: boolean
    params?: ProductAddToCartProductPageMainCtaParams
  }
}> = ({ addToCartParams }) => {
  const { disableCta, params } = addToCartParams
  const globalConfig = useGlobalConfigContext()
  const formRef = useRef<HTMLFormElement>(null)
  const { attributeSelectionControls } = useProductPageContext()
  const onSubmit: FormEventHandler<HTMLFormElement> = (event): void => {
    experimentsTrackEvent(
      globalConfig,
      EXPERIMENT_TRACK_EVENT_OWN_BRANDS_OVERLAY_ADD_TO_CART,
    )
    if (
      !attributeSelectionControls.attributeNotSelectedErrorControls.validateWhenAddingToCart()
    ) {
      event.preventDefault()
    }
  }

  return (
    <form
      action={urlResolverGetCartIntermediatePage(globalConfig)}
      id={EXPERIMENT_OWN_BRANDS_OVERLAY_ADD_TO_CART_FORM_ID}
      onSubmit={onSubmit}
      ref={formRef}
    >
      {Object.entries(
        (params as unknown as Record<string, string> | undefined) ?? {},
      ).map(([name, value]) => {
        return <input key={name} name={name} type="hidden" value={value} />
      })}
      <Button
        className={clsx(
          'w-full',
          'whitespace-pre-wrap',
          'px-4 mobile:px-6',
          styles['product-add-to-cart-cta__button'],
        )}
        data-qa-id="add-to-cart-button"
        disabled={disableCta}
        startIcon={<IconShoppingCart />}
        type="submit"
      >
        <FormattedMessage id="general.button.label.addToCart" />
      </Button>
    </form>
  )
}
